import { AccountSurveyPayload, AccountSurveyType } from '@dev/ee-api/ee-api-models';
import { SurveyData } from '@dev/ee-modules';
import { Action } from 'redux';

export enum OnboardingSurveyActionTypes {
    SAVE_ONBOARDING_SURVEY_START = '@@onboardingsurvey/SAVE_ONBOARDING_SURVEY_START',
    SAVE_ONBOARDING_SURVEY_SUCCESS = '@@onboardingsurvey/SAVE_ONBOARDING_SURVEY_SUCCESS',
    SAVE_ONBOARDING_SURVEY_ERROR = '@@onboardingsurvey/SAVE_ONBOARDING_SURVEY_ERROR',
    LOAD_ONBOARDING_SURVEY_START = '@@onboardingsurvey/LOAD_ONBOARDING_SURVEY_START',
    LOAD_ONBOARDING_SURVEY_SUCCESS = '@@onboardingsurvey/LOAD_ONBOARDING_SURVEY_SUCCESS',
    LOAD_ONBOARDING_SURVEY_ERROR = '@@onboardingsurvey/LOAD_ONBOARDING_SURVEY_ERROR',
}
export enum OnboardingSurveyLoadingState {
    Default = '',
    Loading = 'Loading',
    Loaded = 'Loaded',
    Error = 'Error',
}

export interface SaveOnboardingSurveyStartAction extends Action {
    type: OnboardingSurveyActionTypes.SAVE_ONBOARDING_SURVEY_START;
    payload: SurveyData;
}

export interface SaveOnboardingSurveySuccessAction extends Action {
    type: OnboardingSurveyActionTypes.SAVE_ONBOARDING_SURVEY_SUCCESS;
}

export interface SaveOnboardingSurveyErrorAction extends Action {
    type: OnboardingSurveyActionTypes.SAVE_ONBOARDING_SURVEY_ERROR;
}

export interface LoadOnboardingSurveyStartAction extends Action {
    type: OnboardingSurveyActionTypes.LOAD_ONBOARDING_SURVEY_START;
    payload: {
        type?: AccountSurveyType;
    };
}

export interface LoadOnboardingSurveySuccessAction extends Action {
    type: OnboardingSurveyActionTypes.LOAD_ONBOARDING_SURVEY_SUCCESS;
    payload: AccountSurveyPayload;
}

export interface LoadOnboardingSurveyErrorAction extends Action {
    type: OnboardingSurveyActionTypes.LOAD_ONBOARDING_SURVEY_ERROR;
}
export interface OnboardingSurveyState {
    isSaved: boolean;
    isSaving: boolean;
    loaded: OnboardingSurveyLoadingState;
    completedFormData?: AccountSurveyPayload;
}
